import type {
  UpdateUserAgreementBody,
  UpdateUserAgreementResponse,
  UpdateUserConsultStyleBody,
  UpdateUserConsultStyleResponse,
  GetUserConsultStyleResponse,
  UpdateUserInfoBody,
  UpdateUserInfoResponse,
  GetUserInfoResponse,
  VerifyPinBody,
  VerifyPinResponse,
  CheckPinExistsResponse,
  SetPinBody,
  SetPinResponse,
  WithdrawalResponse,
  WithdrawalBody
} from './model/userType'

import { jwtClientAxios } from './index'

import api from '@/api/url'

export const updateUserAgreementApi = async (
  user_id: number,
  body: UpdateUserAgreementBody
): Promise<UpdateUserAgreementResponse> => {
  const response = await jwtClientAxios().put(api.user.AGREEMENT(user_id), body)
  return response.data
}

export const updateUserConsultStyleApi = async (
  user_id: number,
  body: UpdateUserConsultStyleBody
): Promise<UpdateUserConsultStyleResponse> => {
  const response = await jwtClientAxios().put(api.user.CONSULT_STYLE(user_id), body)
  return response.data
}

export const getUserConsultStyleApi = async (user_id: number): Promise<GetUserConsultStyleResponse> => {
  const response = await jwtClientAxios().get(api.user.CONSULT_STYLE(user_id))
  return response.data
}

export const updateUserInfoApi = async (user_id: number, body: UpdateUserInfoBody): Promise<UpdateUserInfoResponse> => {
  const response = await jwtClientAxios().put(api.user.USER_INFO(user_id), body)
  return response.data
}

export const getUserInfoApi = async (user_id: number): Promise<GetUserInfoResponse> => {
  const response = await jwtClientAxios().get(api.user.USER_INFO(user_id))
  return response.data
}

export const deleteUserApi = async (user_id: number): Promise<string> => {
  const response = await jwtClientAxios().delete(api.user.USER_INFO(user_id))
  return response.data
}

export const verifyPinApi = async (body: VerifyPinBody): Promise<VerifyPinResponse> => {
  const response = await jwtClientAxios().post(api.user.VERIFY_PIN, body)
  return response.data
}

export const checkPinExistsApi = async (): Promise<CheckPinExistsResponse> => {
  const response = await jwtClientAxios().get(api.user.PIN_EXISTS)
  return response.data
}

export const setPinApi = async (body: SetPinBody): Promise<SetPinResponse> => {
  const response = await jwtClientAxios().post(api.user.SET_PIN, body)
  return response.data
}

export const withdrawalApi = async (user_id: number, body: WithdrawalBody): Promise<WithdrawalResponse> => {
  const response = await jwtClientAxios().delete(api.user.USER_INFO(user_id), { data: body })
  return response.data
}
